import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_supplier/layout/MasterLayout'
import {PageTitle} from '../../_supplier/layout/core'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_supplier/assets/ts/_utils'
import {WithChildren} from '../../_supplier/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {KycStepper} from '../modules/auth/kyc-process/KycStepper'
import {WelcomePage} from '../modules/auth/WelcomePage'
import VerifyOTP from '../modules/auth/components/VerifyOTP'
import KycRejected from '../modules/auth/kyc-process/details/kycRejected'
import KycSubmitted from '../modules/auth/kyc-process/details/kycSubmitted'
import {EmptyData} from '../modules/auth/EmptyData'

const PrivateRoutes = () => {
  const PurchaseOrderWrapper = lazy(() => import('../modules/purchase-order/index'))
  const EscalationPage = lazy(() => import('../modules/escalations'))
  const ProductCatalogWrapper = lazy(() => import('../modules/product-catalog/index'))
  const DeliveryShipmentWrapper = lazy(() => import('../modules/delivery-shipment/index'))
  const ProfilePage = lazy(() => import('../modules/profile-management/index'))
  const NotificationsPage = lazy(() => import('../modules/notifications/index'))
  const InventoryWrapper = lazy(() => import('../modules/inventory/index'))
  const DashboardModule = lazy(() => import('../modules/dashboard/index'))
  const MasterModule = lazy(() => import('../modules/master/index'))
  const ProductPage = lazy(() => import('../modules/products/index'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        <Route
          path='dashboard/*'
          element={
            <SuspensedView>
              <DashboardModule />
            </SuspensedView>
          }
        />
        <Route
          path='purchase-order/*'
          element={
            <SuspensedView>
              <PageTitle>PO Management</PageTitle>
              <PurchaseOrderWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='escalations/*'
          element={
            <SuspensedView>
              <PageTitle>Escalations</PageTitle>
              <EscalationPage />
            </SuspensedView>
          }
        />
        <Route
          path='master/*'
          element={
            <SuspensedView>
              <PageTitle>Master</PageTitle>
              <MasterModule />
            </SuspensedView>
          }
        />
        <Route
          path='products/*'
          element={
            <SuspensedView>
              <ProductPage />
            </SuspensedView>
          }
        />
        <Route
          path='delivery-shipment/*'
          element={
            <SuspensedView>
              <PageTitle>Delivery & Shipment</PageTitle>
              <DeliveryShipmentWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='profile-management/*'
          element={
            <SuspensedView>
              <PageTitle>Settings</PageTitle>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='notifications'
          element={
            <SuspensedView>
              <PageTitle>Notifications</PageTitle>
              <NotificationsPage />
            </SuspensedView>
          }
        />
        <Route
          path='inventory/*'
          element={
            <SuspensedView>
              <PageTitle>Inventory</PageTitle>
              <InventoryWrapper />
            </SuspensedView>
          }
        />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
      <Route path='kyc-process' element={<KycStepper />} />
      <Route path='welcome' element={<WelcomePage />} />
      <Route path='verify-otp' element={<VerifyOTP />} />
      <Route path='kyc-rejected' element={<KycRejected />} />
      <Route path='kyc-submitted' element={<KycSubmitted />} />
      <Route path='message' element={<EmptyData />} />
    </Routes>
  )
}
const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}
export {PrivateRoutes}
